import { Link, useOutletContext, useParams } from "react-router";

import { LockIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

import { Project } from "@/features/projects/types";
import CreateTicketForm from "@/features/tickets/components/CreateTicketForm";
import { EmptyState } from "@/shared/components/EmptyState";
import { PERMISSIONS } from "@/shared/lib/constants/permissions";

export default function CreateTicket() {
  const { id } = useParams();
  const { permissions } = useOutletContext<{ project: Project; permissions: string[] }>();

  if (!permissions.includes(PERMISSIONS.PROJECT_TICKETS_CREATE)) {
    return (
      <EmptyState
        icon={LockIcon}
        title="No access"
        description="You don't have permission to create tickets in this project. Contact an administrator to request access."
        action={
          <Button asChild variant="outline" size="sm">
            <Link to={`/projects/${id}/tickets`}>Back to tickets</Link>
          </Button>
        }
      />
    );
  }

  return <CreateTicketForm />;
}
